import { useState, useEffect } from 'react'

import { userService } from '../services'

const useUserImages = (userId: number) => {
  const [userImages, setUserImages] = useState<any>({})

  useEffect(() => {
    if(userId) getUserImages(userId)
  }, [userId])

  const getUserImages = async (userId: number) => {
    const resp = await userService.getUserImages(userId)
    setUserImages(resp.data)
  }

  return {
    userImages
  }
}

export { useUserImages }